import { render } from "./DrawIndexTable.vue?vue&type=template&id=dbc32468"
import script from "./DrawIndexTable.vue?vue&type=script&lang=js"
export * from "./DrawIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__